export const MARKETPLACE_INTEGRATION_KEY = 'marketplaceIntegration'
export const MARKETPLACE_INTEGRATION_STATE_KEY = 'integrationState'